(() => {
  // This showcase moves only when a visitor swipes or uses the keyboard.
  if (window.wbStoryExamples) {
    window.wbStoryExamples.initialize(document);
    return;
  }
  const controllers = new Map();
  function initialize(root) {
    root.querySelectorAll('[data-wb-examples]').forEach(section => {
      if (controllers.has(section)) return;
      const rail = section.querySelector('[data-wb-examples-rail]');
      if (!rail) return;
      const events = new AbortController();
      rail.addEventListener('keydown', event => {
        // Let links keep their native keyboard behavior.
        if (event.target !== rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const end = rail.scrollWidth - rail.clientWidth;
        if (end <= 1) return;
        event.preventDefault();
        const card = rail.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? end : rail.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
        rail.scrollTo({
          left: Math.max(0, Math.min(end, target)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      }, { signal: events.signal });
      controllers.set(section, () => events.abort());
    });
  }
  window.wbStoryExamples = { initialize };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, section) => {
      if (!event.target.contains(section)) return;
      destroy();
      controllers.delete(section);
    });
  });
})();
